import { createTheme, type Theme } from '@mui/material/styles'

// The member theme, made for a mechanic's hands: an iPad or a cheap Android
// tablet held in a hangar, often with gloves or oily fingers. Every control is
// at least 56 px tall (Apple's guideline is 44, Material's 48) and type is a
// step larger than the member app's. Colours, fonts and shape stay the brand's,
// so the two sites read as one intranet.
export const MIN_TOUCH = 56

export function tabletTheme(outer: Theme): Theme {
  return createTheme(outer, {
    typography: {
      fontSize: 16,
      body1: { fontSize: '1.125rem' },
      body2: { fontSize: '1rem' },
      button: { fontSize: '1.125rem', textTransform: 'none', fontWeight: 600 },
    },
    components: {
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: { minHeight: MIN_TOUCH, paddingInline: 24, borderRadius: 14 },
          sizeLarge: { minHeight: 72, fontSize: '1.375rem', borderRadius: 16 },
        },
      },
      MuiIconButton: { styleOverrides: { root: { minWidth: MIN_TOUCH, minHeight: MIN_TOUCH } } },
      MuiToggleButton: {
        styleOverrides: { root: { minHeight: 72, fontSize: '1.375rem', fontWeight: 700, textTransform: 'none' } },
      },
      MuiCheckbox: { styleOverrides: { root: { padding: 12 } } },
      MuiOutlinedInput: { styleOverrides: { root: { fontSize: '1.25rem' }, input: { minHeight: 32 } } },
      MuiInputLabel: { styleOverrides: { root: { fontSize: '1.125rem' } } },
      MuiFormHelperText: { styleOverrides: { root: { fontSize: '0.95rem' } } },
      MuiChip: { styleOverrides: { root: { height: 40, fontSize: '1.05rem', fontWeight: 600 } } },
      MuiListItemButton: { styleOverrides: { root: { minHeight: 76 } } },
      MuiTab: { styleOverrides: { root: { minHeight: MIN_TOUCH, fontSize: '1.05rem' } } },
      MuiDialog: { defaultProps: { fullWidth: true, maxWidth: 'sm' } },
    },
  })
}
